/**
 * Vendor imports
 */

// Lazysizes

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

// Axios

window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

// disable default hash jump behaviour

import '@modules/disable-hash-jump';

// auto remove broken/obsolete basket products so basket keeps on working

import '@modules/localstorage-basket-fix';

/**
 * Vue.js
 */

// Register Vue

window.Vue = require('vue');

// Register Prototype Methods

Vue.prototype.svg = require('@modules/svg');

// Vuex stores

import store from '@/store';

// Vue plugins

import VueSilentbox from 'vue-silentbox';
Vue.use(VueSilentbox);

import VueSmoothScroll from 'vue2-smooth-scroll';
Vue.use(VueSmoothScroll);

import VueCollapse from 'vue2-collapse';
Vue.use(VueCollapse);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import VueCookies from 'vue-cookies';
Vue.use(VueCookies);

const headerHeight = document.getElementsByTagName('header').length > 0 ? document.getElementsByTagName('header')[0].clientHeight : 0;
const topOffset = window.innerWidth < 767.98 ? headerHeight + 56 : headerHeight + 40;

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
    container: 'body',
    duration: 500,
    easing: 'ease',
    offset: topOffset,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true,
});

// Register Custom Components

const files = require.context('./', true, /\.vue$/i);
files.keys().map(key =>
    Vue.component(
        key
            .split('/')
            .pop()
            .split('.')[0],
        files(key).default,
    ),
);

/**
 * Create Vue Instances
 */

// root mixins

import rootVariables from '@mixins/root/root-variables';
import anchorEvents from '@mixins/root/anchor-events';

// Create Vue event bus

export const bus = new Vue();

import { i18n } from '@/localization';
import { VueReCaptcha } from 'vue-recaptcha-v3';

// Create main Vue instance
Vue.use(VueReCaptcha, {
    siteKey: process.env.MIX_RECAPTCHA_SITE_KEY,
    loaderOptions: {
        autoHideBadge: true,
    },
});
// Create main Vue instance

new Vue({
    el: '#app',
    store,
    i18n,
    mixins: [rootVariables, anchorEvents],
    mounted() {
        this.getCustomer();
    },
    methods: {
        getCustomer() {
            axios.get('/api/customer').then(response => {
                if (response && response.data) {
                    this.$store.dispatch('setCustomer', response.data);
                } else {
                    this.$store.dispatch('setCustomer', { reseller_id: null, pricesIncludingVat: localStorage.getItem('prices_including_vat') !== 'false' });
                }
            });
        },
    },
});
